import * as _ from 'underscore';
import { BaseUIElement } from './baseUIElement';
import { Util } from '../..';
import { ISerializable } from '../../../interfaces';
import { IKeyValue } from '../../../interfaces';
import { LabelCellElement, ValidationCellElement, WidgetCellElement } from '../cellElements';
import { IUIElementOptions } from '../../../interfaces/options';
import { DEFAULTUIELEMENTOPTIONS } from '../../../const/defaultOptions';

export class UIElement<T> extends BaseUIElement implements ISerializable<IKeyValue<any>> {
	public value: KnockoutObservable<T>;
	public label: LabelCellElement;
	private validation: ValidationCellElement;
	public isRequired: KnockoutComputed<boolean>;
	public editable: KnockoutObservable<boolean>;
	protected widget: WidgetCellElement<T>;
	public hasFocus: KnockoutObservable<boolean>;
	public constructor(
		id: string,
		label: string,
		value: T | KnockoutObservable<T>,
		options?: IUIElementOptions
	) {
		options = $.extend(true, {}, DEFAULTUIELEMENTOPTIONS, options || {});
		super(id, label, options);
		this.hasFocus = ko.observable<boolean>(false);
		this.value = ko.isObservable(value) ? <KnockoutObservable<T>>value : ko.observable<T>(<T>value);
		this.editable = ko.isObservable(options.editable)
			? <KnockoutObservable<boolean>>options.editable
			: ko.observable(<boolean>options.editable);
		//Rules
		if (options.rules.length > 0) {
			options.rules.forEach(rule => ko.validation.addRule(this.value, rule));
		}
		this.isRequired = ko.pureComputed(() => {
			return (
				this.value.rules &&
				ko.isObservable(this.value.rules) &&
				_.any(this.value.rules(), rule => {
					return (
						rule.rule == 'required' &&
						rule.params &&
						ko.utils.unwrapObservable(rule.params) &&
						(!rule.condition || rule.condition())
					);
				})
			);
		});
		this.label = new LabelCellElement(this, label, this.editable, options.label);
		this.widget = new WidgetCellElement<T>(this, this.value, this.editable, options.widget);
		this.validation = new ValidationCellElement(this, this.editable, options.validation);
	}
	public serialize(serializeObject: IKeyValue<any>): IKeyValue<any> {
		serializeObject[this.id] = this.value();
		return serializeObject;
	}
	public setRequired(
		required: boolean,
		rule: KnockoutValidationRule = <KnockoutValidationRule>{ rule: 'required', params: true }
	) {
		var isRequired = this.isRequired();
		if ((isRequired && required) || (!isRequired && !required)) {
			return;
		}
		if (required) {
			ko.validation.addRule(this.value, rule);
		} else {
			Util.removeRules(this.value, ['required']);
		}
	}
}
